var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roleBackground"},[(_vm.refresh)?_c('BottomRole',{attrs:{"roleId":_vm.$route.params.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }